















































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';
import {getModule} from 'vuex-module-decorators';

import {LoraForwarderGatewayConfiguration} from '@/model/lora/UdpPacketForwarder/LoraForwarderUdpConfig';

import {ILoraForwarderUdpService} from '@/services/lora/forwarder/ILoraForwarderUdp.service';

import LoraForwarderUdpStore from '@/store/lora/LoraForwarderUdp.store';

import JsonEditor from '@/components/Utils/JsonEditor.vue';
import LoraForwarderConfigFileEditor from '@/components/Lora/Forwarder/LoraForwarderConfigFileEditor.vue';
import LoraForwarderControl from '@/components/Lora/Forwarder/LoraForwarderControl.vue';
import LoraForwarderConfiguration from '@/components/Lora/Forwarder/LoraForwarderConfiguration.vue';
import LoraForwarderLog from '@/components/Lora/Forwarder/LoraForwarderLog.vue';
import LoraForwarderStats from '@/components/Lora/Forwarder/LoraForwarderStats.vue';

import {BaseComponent} from '@/mixins/BaseComponent';
import LoraForwarderPacketsLog from '@/components/Lora/Forwarder/LoraForwarderPacketsLog.vue';
import LoraForwarderFrequencyPlanEditor from '@/components/Lora/Forwarder/LoraForwarderFrequencyPlanEditor.vue';

@Component({
  components: {
    LoraForwarderFrequencyPlanEditor,
    LoraForwarderPacketsLog,
    LoraForwarderStats,
    JsonEditor,
    LoraForwarderLog,
    LoraForwarderConfigFileEditor,
    LoraForwarderControl,
    LoraForwarderConfiguration,
  },
})
export default class LoraForwarderUdpSettings extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ILoraForwarderUdpService'))
  private loraForwarderUdpService!: ILoraForwarderUdpService;

  private forwarderStore: LoraForwarderUdpStore = getModule(LoraForwarderUdpStore, this.$store);

  private configuration: LoraForwarderGatewayConfiguration | any = {};

  private configurationEditor = false;

  private async mounted() {
    await this.refreshConfig();
    this.setLoaded();
  }

  private async refreshConfig() {
    try {
      this.configuration = await this.loraForwarderUdpService.getConfig();
    } catch (error) {

    }
  }

  private async configClose() {
    this.configurationEditor = false;
    this.refreshConfig();
  }
}

